import type { RouteRecordRaw } from 'vue-router'

import Campaigns from '@/views/Campaigns/Index.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {
            title: 'campaigns.pageTitle',
            menuRendered: true,
            menuTitle: 'campaigns.menuTitle',
            requiresAuth: true,
            permission: 'jmd_campaign',
            icon: 'mdi-bullhorn-outline'
        },
        children: [
            {
                path: '/campaigns/campaigns',
                name: 'campaignsCampaigns',
                component: () => import('@/views/Campaigns/Campaigns/Index.vue'),
                meta: {
                    title: 'campaigns.campaigns.pageTitle',
                    menuRendered: true,
                    menuTitle: 'campaigns.campaigns.menuTitle',
                    requiresAuth: true,
                    permission: 'jmd_campaign_read'
                }
            },
            {
                path: '/campaigns/campaigns/:id',
                name: 'campaignsCampaignsDetail',
                component: () => import('@/views/Campaigns/Campaigns/Campaign.vue'),
                meta: {
                    title: 'campaigns.campaigns.detailPageTitle',
                    requiresAuth: true,
                    permission: 'jmd_campaign_read'
                }
            }
        ]
    }
]

export default routes
